import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DailyTotalsOverviewPage } from '../../pages/daily-totals-overview/daily-totals-overview';
import { NotificationsPage } from '../../pages/notifications/notifications';
import { ProfilePage } from '../../pages/profile/profile';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {

  tab1Root: any = DailyTotalsOverviewPage;
  tab2Root: any = NotificationsPage;
  tab3Root: any = ProfilePage;
  mySelectedIndex: number;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TabsPage');
  }
}




// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts